import React, { useState } from 'react';
import '../css/lazy-image.css';

const LazyImage = ({ src, alt, className }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    return (
        <div className={`lazy-image-wrapper ${className || ''}`}>
            {!loaded && !error && (
                <div className="image-skeleton">
                    <span className="skeleton-text">UrbanThreads</span>
                </div>
            )}
            {!error ? (
                <img
                    src={src}
                    alt={alt || 'Product'}
                    className={`lazy-image ${loaded ? 'visible' : 'hidden'}`}
                    onLoad={() => setLoaded(true)}
                    onError={() => {
                        console.error("Image failed to load:", src);
                        setError(true);
                    }}
                    loading="lazy"
                />
            ) : (
                <div className="image-error">
                    <span className="error-text">Failed to load image</span>
                </div>
            )}
        </div>
    );
};

export default LazyImage;